<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12">
    <path
      d="M3.375.63H.551A.532.532 0 0 0 0 1.159c0 .299.24.533.55.533h2.58a.46.46 0 0 1 .451.288l3.861 8.671c.217.493.575.721 1.114.721h2.86c.304 0 .55-.234.55-.527a.543.543 0 0 0-.55-.534H8.817c-.234 0-.38-.087-.474-.28L4.5 1.362A1.197 1.197 0 0 0 3.375.631Zm8.04 0H7.622c-.31 0-.55.224-.55.522 0 .3.24.528.55.528h3.791c.31 0 .545-.229.545-.528 0-.298-.234-.521-.545-.521Z"
      fill="currentColor"
    />
  </svg>
</template>
